<mat-icon (click)="onCopy()" [cdkCopyToClipboard]="value | laSeparator: '; '" [ngClass]="{ copied: status$ | async }">{{
  (status$ | async) ? 'done' : 'content_copy'
}}</mat-icon>
